import SiteTrack from "../../Site-Track/components/SiteTrack.vue";

export default [
    {
        path: "/SiteTrack/preventative/:subPage",
        name: "Preventative Maintenance",
        component: SiteTrack,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          feature: "preventive_maintenance",
          title: (route) => {
            const map = {
              all_work_orders: "PM Work Orders",
              // to_assign: "PM To Assign",
              scheduling: "PM Scheduling",
              active_work_orders: "Active PM Orders",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/SiteTrack/corrective/:subPage",
        name: "Corrective Maintenance",
        component: SiteTrack,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          feature: "corrective_maintenance",
          title: (route) => {
            const map = {
              all_work_orders: "CM Work Orders",
              issues: "CM Issues",
              // to_assign: "CM To Assign",
              active_work_orders: "Active CM Orders",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/SiteTrack/incident",
        name: "Incident Tracking",
        component: SiteTrack,
        meta: { requiresAuth: true, checkPermissions: true, module: "site_track", feature: "incident_tracking", title: "CruzControl | Incidents" }
    },
    {
        path: "/SiteTrack/inventory/:subPage",
        name: "Inventory",
        component: SiteTrack,
        props: route => ({ query: route.query.q }),
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          feature: "inventory",
          title: (route) => {
            const map = {
              inventory_items: "Inventory",
              on_hand_records: "Transactions",
              maintenance_accounting: "Maintenance Accounting",
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/SiteTrack/assets",
        name: "Assets",
        component: SiteTrack,
        meta: { requiresAuth: true, checkPermissions: true, module: "site_track", feature: "assets", title: "CruzControl | Assets" }
    },
    {
        path: "/SiteTrack/purchasing/:subPage/:action?",
        name: "Purchasing",
        component: SiteTrack,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          feature: "purchasing",
          title: (route) => {
            const map = {
              purchase_orders: "Purchase Orders",
              "purchase_orders/new": "New Purchase Order",
              order_receipts: "Receipts",
              "order_receipts/new": "New Receipt",
            }

            const { subPage, action } = route.params

            const key = action ? `${subPage}/${action}` : subPage

            return map[key] ? `CruzControl | ${map[key]}` : null
          }
      }
    },
    {
        path: "/SiteTrack/manager_tools/:subPage",
        name: "Manager Tools",
        component: SiteTrack,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          feature: "manager_tools",
          title: (route) => {
            const map = {
              labor_charges: "Labor Charges",
              team_management: "Team Management",
              define_new_procedure: "New Procedure",
              view_edit_procedures: "Procedures"
            }

            return map[route.params.subPage] ? `CruzControl | ${map[route.params.subPage]}` : null;
          }
        }
    },
    {
        path: "/SiteTrack",
        name: "Site Track",
        component: SiteTrack,
        meta: {
          requiresAuth: true,
          checkPermissions: true,
          module: "site_track",
          title: "CruzControl | Site Track"
        }
    },
]